import { render, staticRenderFns } from "./SpeakingPhonicsForm.vue?vue&type=template&id=42671454&"
import script from "./SpeakingPhonicsForm.vue?vue&type=script&lang=js&"
export * from "./SpeakingPhonicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports